import { forwardRef, InputHTMLAttributes } from 'react'
import styled, { css } from 'styled-components'

interface IFProps extends InputHTMLAttributes<HTMLInputElement> {
  label: number | string
}

const AnswerRadioButton = forwardRef<HTMLInputElement, IFProps>(
  ({ id, label, ...restRadioProps }, radioRef) => {
    return (
      <StyledWrapper>
        <input ref={radioRef} id={id} type="radio" {...restRadioProps} />
        <label htmlFor={id}>{label}</label>
      </StyledWrapper>
    )
  },
)

export default AnswerRadioButton

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    & > input[type='radio'] {
      display: none;

      &:checked + label {
        background-color: #01a0ff;
        border: 1px solid #01a0ff;
        color: #fff;
      }
    }

    > label {
      width: 32px;
      height: 32px;
      border: solid 1px ${theme.line.line_2};
      border-radius: 8px;
      background-color: ${theme.background.bg_8};
      color: ${theme.color.text_1};
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  `}
`
